module.exports = __webpack_public_path__ + "static/media/image_19.ff20efa4.png";